<template>
  <div v-if="activeForm" class="booking_user">
    <b-tabs pills card>
      <b-tab
        :title="
          track_trace != null ? 'Booking Request' : 'Quotation information '
        "
        :active="activeTabAll == 0"
        @click="
          () => {
            (this.activeTabAll = 0), this.reload++;
          }
        "
        v-if="request_quotation != null"
      >
        <b-card-text>
          <vue-perfect-scrollbar
            ref="scrollContainer"
            :settings="{
              maxScrollbarLength: 150,
              suppressScrollX: true,
            }"
            :style="{
              maxHeight: isCustomer
                ? status == 5 || status == 6
                  ? '62vh'
                  : '70vh'
                : '84vh',
              paddingBottom: isCustomer ? '3rem' : '10rem',
            }"
            class="scrollable-container scroll-area"
          >
            <keep-alive>
              <div class="mx-1">
                <component
                  v-if="
                    request_quotation.service_type == '3' &&
                    step != 'view-created-quotation'
                  "
                  :is="isCustomer ? 'NewBookingKH' : 'NewBookingSale'"
                  :key="reload"
                  isCustomer
                  :step="step"
                  :view_RequestQuotation="request_quotation"
                  :booking="booking"
                  @clickActiveTab="activeTabAll = 3"
                  className="mybooking-online"
                  :readonly="true"
                />
                <component
                  v-else-if="
                    request_quotation.service_type == '5' &&
                    step != 'view-created-quotation'
                  "
                  :is="isCustomer ? 'ContainerTruckKH' : 'ContainerTruckSale'"
                  isCustomer
                  :step="step"
                  :key="reload"
                  :view_RequestQuotation="request_quotation"
                  :booking="booking"
                  @clickActiveTab="activeTabAll = 3"
                  className="mybooking-online"
                  :readonly="true"
                />
                <component
                  v-else-if="
                    request_quotation.service_type == '6' &&
                    step != 'view-created-quotation'
                  "
                  :is="isCustomer ? 'VanTruckKH' : 'VanTruckSale'"
                  isCustomer
                  :key="reload"
                  :step="step"
                  :view_RequestQuotation="request_quotation"
                  :booking="booking"
                  @clickActiveTab="activeTabAll = 3"
                  className="mybooking-online"
                  :readonly="true"
                />
                <RequestQuotation
                  v-else
                  isCustomer
                  :step="step"
                  :view_RequestQuotation="request_quotation"
                  :booking="booking"
                  @clickActiveTab="activeTabAll = 3"
                  className="mybooking-online"
                  :readonly="true"
                />
              </div>
            </keep-alive>
          </vue-perfect-scrollbar>
          <div
            class="flex justify-end mt-35"
            v-if="isCustomer && (status == 5 || status == 6)"
          >
            <div
              class="custom-btn-cancel pl-2 pr-2 mr-1 btn"
              @click="
                () => {
                  $bvModal.show('cancel-booking');
                  cancel_reason = '';
                }
              "
            >
              Cancel
            </div>
          </div>
        </b-card-text>
      </b-tab>
      <!-- RequestBookingNote -->
      <b-tab
        title="
         Shipment detail
        "
        @click.prevent="activeTabAll = 15"
        :active="activeTabAll == 15"
        :title-item-class="
          (request_quotation && [5, 6, 61, 16].includes(status)) ||
          (request_quotation && [5, 6, 61, 16].includes(status) && isCustomer)
            ? 'd-none'
            : ''
        "
      >
        <b-card-text>
          <ShipmentDetail
            ref="shipmentDetail"
            isCustomer
            :proc_code="proc_code"
            :step="step"
            :bookingId="booking.id"
            @RequestAnUpdateEvent="$emit('RequestAnUpdateEvent')"
            :request_quotation="request_quotation"
            className="mybooking-online"
            :readonly="true"
            :tempViewBooking="tempViewBooking"
            :shipmentOnTms="shipment_on_tms"
            :shipmentOnFast="shipment_on_fast"
            :shipmentDetail="shipment_detail"
          />
        </b-card-text>
      </b-tab>
      <!-- <b-tab
                title="Quotation"
                @click.prevent="activeTabAll = 1"
                :active="activeTabAll == 1"
                v-if="quotation != null && quotation.hasOwnProperty('valid_to')"
            >
                <b-card-text>
                    <create-quotation
                        :isCustomer="isCustomer"
                        :step="step"
                        :readonly="true"
                        :request_quotation="request_quotation"
                        :view_quotation="quotation"
                        @AcceptBookingEvent="$emit('AcceptBookingEvent')"
                        @CancelBookingEvent="$emit('CancelBookingEvent')"
                        @loadMyQuotation="$emit('loadMyQuotation')"
                        @EditBookingEvent="$emit('EditBookingEvent')"
                        @CustomerBookingEvent="$emit('CustomerBookingEvent')"
                        @acceptQuotationEvent="$emit('acceptQuotationEvent')"
                        @RequestAnUpdateEvent="$emit('RequestAnUpdateEvent')"
                    />
                </b-card-text>
            </b-tab> -->
      <b-tab
        title="Quote"
        @click.prevent="activeTabAll = 2"
        :active="activeTabAll == 2"
        v-if="booking != null"
      >
        <b-card-text>
          <create-quotation
            :key="reloadShipmentDetail"
            ref="CreateQuotation"
            :isCustomer="isCustomer"
            :step="'booking'"
            :readonly="isCustomer"
            :proc_code="proc_code"
            :status="status"
            :request_quotation="request_quotation"
            :booking="booking"
            :shipmentDetail="shipment_detail"
            :view_quotation="quotation"
            @AcceptBookingEvent="$emit('AcceptBookingEvent')"
            @CancelBookingEvent="$emit('CancelBookingEvent')"
            @loadMyQuotation="$emit('loadMyQuotation')"
            @EditBookingEvent="$emit('EditBookingEvent')"
            @NewShipmentToFast="sendShipmentDetailsFast"
            @NewShipmentToTMS="sendShipmentDetailsTms"
            @UpdateShipmentDetail="updateShipmentDetailSendTms"
            @CustomerBookingEvent="$emit('CustomerBookingEvent')"
            @acceptQuotationEvent="$emit('acceptQuotationEvent')"
            @RequestAnUpdateEvent="$emit('RequestAnUpdateEvent')"
          />
        </b-card-text>
      </b-tab>
      <b-tab
        title="Booking Note"
        :active="activeTabAll == 8"
        @click.prevent="activeTabAll = 8"
        v-if="
          (![5, 6, 61, 16].includes(status) &&
            request_quotation.service_type == '3' &&
            !isCustomer) ||
          (![5, 6, 61, 16, 17].includes(status) &&
            request_quotation.service_type == '3')
        "
      >
        <b-card-text>
          <vue-perfect-scrollbar
            :settings="{
              maxScrollbarLength: 150,
              suppressScrollX: true,
            }"
            style="max-height: 60vh"
            class="scrollable-container scroll-area"
          >
            <RequestBookingNote
              @clickActiveTab="activeTabAll = 3"
              @NewBookingNote="postBookingNote"
              :shipmentDetail="shipment_detail"
              v-model="booking_note"
              :status="status"
              @readonly="readonlyBookingNote = false"
              @ReceivedReviseRequest="reviseBookingNote"
              :request_quotation="request_quotation"
              :readonly.sync="isReadonly"
              :isCustomer="isCustomer"
              :tempViewBooking="tempViewBooking"
              :key="reloadNote"
            />
          </vue-perfect-scrollbar>
        </b-card-text>
      </b-tab>

      <b-tab
        title="Cost"
        @click.prevent="activeTabAll = 3"
        :active="activeTabAll == 3"
        v-if="
          status != 5 &&
          status != 6 &&
          status != 61 &&
          status != 16 &&
          !isCustomer &&
          track_trace != null
        "
      >
        <b-card-text>
          <create-cost
            :status="status"
            :isCustomer="isCustomer"
            :step="'booking'"
            :readonly="true"
            :request_quotation="request_quotation"
            :booking="booking"
            :costs_info="costs_info"
            :view_quotation="quotation"
            @AcceptBookingEvent="$emit('AcceptBookingEvent')"
            @CancelBookingEvent="$emit('CancelBookingEvent')"
            @loadMyQuotation="$emit('loadMyQuotation')"
            @EditBookingEvent="$emit('EditBookingEvent')"
            @NewShipmentToFast="$emit('NewShipmentToFast')"
            @NewShipmentToTMS="$emit('NewShipmentToTMS')"
            @CustomerBookingEvent="$emit('CustomerBookingEvent')"
            @acceptQuotationEvent="$emit('acceptQuotationEvent')"
            @RequestAnUpdateEvent="$emit('RequestAnUpdateEvent')"
          />
        </b-card-text>
      </b-tab>
      <b-tab
        title="Shiping Instruction"
        @click.prevent="activeTabAll = 4"
        :active="activeTabAll == 4"
        v-if="
          track_trace != null &&
          (status == 7 || status == 8 || status == 9) &&
          (request_quotation.service_type == 1 ||
            request_quotation.service_type == 2 ||
            request_quotation.service_type == 3)
        "
      >
        <b-card-text>
          <creat-shiping-intruction
            :isCustomer="isCustomer"
            :step="'booking'"
            :readonly="
              request_quotation && request_quotation.accept_edit != 1
                ? true
                : [61, 9, 8].includes(status)
                ? false
                : !enableEditBooking
            "
            :request_quotation="request_quotation"
            :booking="booking"
            :costs_info="costs_info"
            :view_quotation="quotation"
            @AcceptBookingEvent="$emit('AcceptBookingEvent')"
            @CancelBookingEvent="$emit('CancelBookingEvent')"
            @loadMyQuotation="$emit('loadMyQuotation')"
            @EditBookingEvent="$emit('EditBookingEvent')"
            @NewShipmentToFast="$emit('NewShipmentToFast')"
            @NewShipmentToTMS="$emit('NewShipmentToTMS')"
            @CustomerBookingEvent="$emit('CustomerBookingEvent')"
            @acceptQuotationEvent="$emit('acceptQuotationEvent')"
            @RequestAnUpdateEvent="$emit('RequestAnUpdateEvent')"
          />
        </b-card-text>
      </b-tab>
      <b-tab
        title="Track & trace"
        @click.prevent="activeTabAll = 6"
        :active="activeTabAll == 6"
        v-if="
          track_trace != null &&
          [
            7, 8, 9, 11, 13, 12, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
            37, 38, 39, 40, 41, 42, 43, 44,
          ].includes(status)
        "
      >
        <b-card-text>
          <vue-perfect-scrollbar
            :settings="{
              maxScrollbarLength: 150,
              suppressScrollX: true,
            }"
            style="height: 70vh"
            class="scrollable-container scroll-area"
          >
            <track-trace
              :bookingID="booking.id"
              :track_trace="track_trace"
              :shipment="shipment"
              :request_quotation="request_quotation"
              :shipment_on_fast="shipment_on_fast"
              :shipment_on_tms="shipment_on_tms"
            />
          </vue-perfect-scrollbar>
        </b-card-text>
      </b-tab>
      <b-tab
        title="Document"
        @click.prevent="activeTabAll = 7"
        :active="activeTabAll == 7"
      >
        <vue-perfect-scrollbar
          :settings="{
            maxScrollbarLength: 150,
            suppressScrollX: true,
          }"
          style="height: 80vh"
          class="scrollable-container scroll-area pb-5"
        >
          <b-row>
            <b-col>
              <ComponentDataQuote :request_quotation="request_quotation" />
            </b-col>
            <b-col cols="12" class="border-bottom">
              <vue-dropzone
                ref="addFile"
                id="addFile"
                :options="dropzoneOptions"
                :useCustomSlot="true"
                :include-styling="false"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="vdropzoneError"
              >
                <div class="dropzone-custom-content">
                  <b-button
                    v-if="
                      this.userData.userType !=
                      this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale
                        ? true
                        : this.request_quotation &&
                          this.request_quotation.accept_edit == 1
                        ? true
                        : false
                    "
                    variant="primary"
                    class="btn-sm float-right my-1"
                    ><feather-icon icon="PlusIcon" /> Add File</b-button
                  >
                </div>
              </vue-dropzone>
            </b-col>
          </b-row>

          <b-card-text>
            <b-row>
              <b-col>
                <vue-good-table
                  :sort-options="{ enabled: false }"
                  :columns="document_columns"
                  :rows="document_rows"
                  class="mb-5 vue-table-new-docs"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'number'">
                      {{ props.index + 1 }}
                    </span>
                    <span v-if="props.column.field === 'document_name'">
                      {{ props.row.name }}
                    </span>
                    <span v-if="props.column.field === 'username'">
                      {{ props.row.username }}
                    </span>
                    <span
                      v-else-if="
                        props.column.field === 'text' && props.row.tms_path
                      "
                    >
                      <div
                        v-if="checkInput(props.row.text, typeView)"
                        @click="viewFile(props.row)"
                        class="custom-view-container-img"
                      >
                        <img
                          v-if="isImage(props.row.tms_path)"
                          :src="props.row.tms_path"
                          class="custom-view-img"
                        />
                      </div>
                    </span>
                    <span
                      v-else-if="
                        props.column.field === 'text' && !props.row.tms_path
                      "
                    >
                      <div
                        v-if="checkInput(props.row.text, typeView)"
                        @click="viewFile(props.row)"
                        class="custom-view-container-img"
                      >
                        <ComponentViewFile :row="props.row" />
                      </div>
                      <div
                        v-else="!checkInput(props.row.text, typeView)"
                        class="custom-view-container-img"
                      >
                        <ComponentViewFile :row="props.row" />
                      </div>
                    </span>
                    <span v-else-if="props.column.field === 'action'">
                      <a style="padding: 5px">
                        <b-img
                        v-if="isImageOrPdf(props.row.tms_path)"

                          width="18px"
                          @click="
                            () => {
                              return checkInput(props.row.text, typeView)
                                ? viewFile(props.row)
                                : 0;
                            }
                          "
                          :src="iconView"
                          alt="logo"
                        />
                        <!-- <feather-icon
                      @click="viewFile(props.row)"
                      icon="EyeIcon"
                    /> -->
                      </a>
                      <!-- :href="props.row.download_path || props.row.tms_path" -->
                      <a
                        class="ml-1"
                        @click="
                          downloadFile(props.row, props.index + 1 + '_img')
                        "
                        style="padding: 5px"
                      >
                        <!-- <feather-icon icon="DownloadIcon"
                  /> -->
                        <b-img width="18px" :src="iconDownload" alt="logo" />
                      </a>
                      <a
                        class="ml-1"
                        @click="
                          () => {
                            return checkInput(props.row.text, typeView)
                              ? printPage(props.row)
                              : 0;
                          }
                        "
                        style="padding: 5px"
                      >
                        <!-- <feather-icon icon="DownloadIcon"
                  /> -->
                        <b-img width="18px" :src="iconPrint" alt="logo" />
                      </a>
                      <a
                        v-if="
                          userData.username == props.row.username ||
                          userData.username == 'admin'
                        "
                        class="ml-1 text-danger"
                        @click="removeFile(props.row)"
                      >
                        <!-- <feather-icon icon="DeleteIcon"
                  /> -->
                        <b-img width="18px" :src="iconDelete" alt="logo" />
                      </a>
                    </span>
                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-card-text>
        </vue-perfect-scrollbar>
      </b-tab>
      <!-- <b-tab
        :key="reloadShipmentDetail"
        title="SeaRates Api Test"
        @click.prevent="activeTabAll = 8"
        :active="activeTabAll == 8"
      >
        <SeaRates v-if="activeTabAll == 8" :request_quotation="request_quotation"   />
      </b-tab> -->
    </b-tabs>
    <b-modal id="add-file" title="Add File" size="lg" hide-footer>
      <b-card-text>
        <label>Import File</label>
      </b-card-text>
    </b-modal>

    <b-modal v-model="fileUpload" title="Add File" size="lg" hide-footer>
      <b-card-text>
        <p>File: {{ nameFile }}</p>

        <b-form-group>
          <label>Notes</label>
          <b-form-textarea rows="4" v-model="notes"></b-form-textarea>
        </b-form-group>

        <b-button
          @click="saveFile"
          variant="primary"
          class="btn-sm float-right my-1"
          >Save</b-button
        >
      </b-card-text>
    </b-modal>
    <b-modal
      id="view-file-print"
      title="View File Print"
      :size="type ? 'lg' : 'xl'"
      hide-footer
    >
      <object>
        <iframe
          ref="pdfEmbed"
          :src="pdfUrl"
          type="application/pdf"
          style="width: 100%; height: 800px"
        ></iframe>
      </object>
    </b-modal>
    <b-modal
      id="view-file"
      title="View File"
      :size="type ? 'lg' : 'xl'"
      hide-footer
    >
      <div v-if="type">
        <img
          class="w-100"
          v-if="base64"
          style="display: block"
          id="base64image"
          :src="'data:image/png;base64,' + base64"
        />
      </div>

      <object v-else>
        <embed
          id="pdfID"
          class="w-100"
          style="height: 100vh"
          type="text/html"
          :src="base64"
        />
      </object>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      id="cancel-booking"
      title="Cancel Booking"
      @ok="handCancelBooking"
    >
      <b-card-text>
        <validation-observer ref="cancelRules">
          <validation-provider
            name="Reason"
            #default="{ errors }"
            rules="required"
          >
            <b-form-textarea
              :class="errors.length > 0 ? 'is-invalid' : null"
              rows="5"
              v-model="cancel_reason"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </validation-observer>
      </b-card-text>
    </b-modal>
  </div>
</template>
<style lang="scss">
.mt-35 {
  margin-top: 3.5rem;
}

.justify-end {
  justify-content: end;
}

.custom-btn-cancel {
  background-color: #6e6b7b;
  color: white;
  display: flex;
  justify-content: end;
  width: 95px;
}

.custom-btn-cancel:hover {
  color: white;
  opacity: 0.7;
}

.booking_user {
  & .nav-pills .nav-link {
    padding: 1rem 1rem;
    width: 200px;
    height: 35px;
    line-height: inherit;
    font-size: 17px;
    font-weight: 500;
  }

  & .nav {
    column-gap: 4.2rem;
    row-gap: 1rem;
    // gap: 4.2rem;
  }

  & .card-header {
    background: white;

    & ul {
      & li {
        & a {
          background-color: #dddddd;
          color: #5e5873;
          // margin-right: 50px;
        }
      }
    }
  }

  & .red {
    color: red;
  }

  & .vue-dropzone > .dz-preview .dz-details {
    background-color: #2b938c;
    border-radius: 15px;
  }

  & .table-print {
    border-collapse: collapse !important;
    width: 100%;
    border: 1px solid #333 !important;
  }

  & .table-print td {
    text-align: left;
  }

  & .table-print th {
    text-align: center;
  }

  & .table-print td,
  & .table-print th {
    border-bottom: 1px solid #333 !important;
    border-right: 1px solid #333 !important;
    padding: 4px 6px;
  }

  & .table-print th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #2b938c;
    color: white;
  }
}
</style>
<script>
import {
  BTab,
  BTabs,
  BAvatar,
  BForm,
  BFormTextarea,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
// import RequestQuotation from "./quotation/RequestQuotation.vue";
import CreateCost from "./quotation/CreateCost.vue";
import CreatShipingIntruction from "./quotation/CreatShipingIntruction.vue";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import vue2Dropzone from "vue2-dropzone";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { $ctx } from "@themeConfig";
import ShipmentDetail from "./quotation/ShipmentDetail.vue";
import RequestBookingNote from "@/views/wr1/booking-note/RequestBookingNote.vue";
import axios from "@axios";
import { saveAs } from "file-saver";
import { CustomerBooking, ReceivedReviseRequest, ReleaseBooking } from "@/api";
import ComponentDataQuote from "./V2/ComponentDataQuote/index";
import { mapState, mapActions } from "vuex";
import ComponentViewFile from "./V2/ComponentDataQuote/index";
import jsPDF from "jspdf";
import "vue-pdf-app/dist/icons/main.css";
import SeaRates from "./searates/index";
export default {
  props: {
    shipment_on_tms: { default: null },
    shipment_on_fast: { default: null },
    shipment_detail: { default: null },
    request_quotation: { default: null },
    quotation: { default: null },
    booking: { default: null },
    costs_info: { default: null },
    track_trace: { default: null },
    shipment: { default: null },
    isCustomer: { default: null },
    activeTab: { default: 0 },
    enableEditBooking: { default: false },
    step: { default: false },
    booking_note: { default: null },
    isUpdate: { default: false },
    proc_code: { default: null },
    status: { default: null },
  },
  components: {
    VueGoodTable,
    RequestBookingNote,
    BTab,
    BTabs,
    RequestQuotation: () => import("./quotation/RequestQuotation.vue"),
    ComponentDataQuote: () => import("./V2/ComponentDataQuote/index.vue"),
    ComponentViewFile: () => import("./V2/ComponentViewFile/index.vue"),
    CreateQuotation: () => import("./quotation/CreateQuotation.vue"),
    NewBookingSale: () => import("./V2/NewBookingSale/index.vue"),
    NewBookingKH: () => import("./V2/NewBookingKH/index.vue"),
    ContainerTruckSale: () => import("./V2/NewContainerTruckSale/index.vue"),
    ContainerTruckKH: () => import("./V2/NewContainerTruckKH/index.vue"),
    VanTruckKH: () => import("./V2/NewVanTruckKH/index.vue"),
    VanTruckSale: () => import("./V2/NewVanTruckSale/index.vue"),
    SeaRates,
    ShipmentDetail,
    VuePerfectScrollbar,
    CreateCost,
    CreatShipingIntruction,
    BAvatar,
    BForm,
    BImg,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    FeatherIcon,
    TrackTrace: () => import("./quotation/TrackTrace.vue"),
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      reloadShipmentDetail: 1,
      reloadNote: 33,
      BookingID: null,
      pdfUrl: "",
      pdfLoaded: false,
      iconDelete: require("@/assets/images/icons/icon-delete.png"),
      iconDownload: require("@/assets/images/icons/icon-download.png"),
      iconPrint: require("@/assets/images/icons/icon-print.png"),
      iconView: require("@/assets/images/icons/icon-view.png"),
      tempViewBooking: {
        vessel: null,
        etd: null,
        cargo_closing_date: null,
        cargo_closing_time: null,
        doc_cut_off_date: null,
        doc_cut_off_time: null,
        prepaid: false,
        collect: false,
        stack_able: false,
        non_stack_able: false,
        rotatable: false,
        oversize: false,
        overweight: false,
        transit_port: null,
        mo_ta: null,
        showAddMore: [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ],
      },
      reload: 0,
      images: [],
      readonlyBookingNote: true,
      type: true,
      base64: "",
      customer_list_options: [],
      typeView: ["png", "jpg", "pdf", "jpeg", "gif", "bmp"],
      typeViewImg: ["png", "jpg", "jpeg", "gif", "bmp"],
      nameFile: "",
      responseFileUp: "",
      fileUpload: false,
      notes: "",
      file: "",
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        previewsContainer: false,
        createImageThumbnails: false,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        destroyDropzone: true,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      userData: JSON.parse(localStorage.getItem("userData")),

      document_columns: [
        {
          label: "NO",
          width: "120px",
          tdClass: "text-center",
          field: "number",
        },
        {
          label: "File",
          field: "text",
          tdClass: "items-center",
          width: "220px",
        },
        {
          label: "Trucking ID",
          field: "trucking_id",
          filterOptions: { enabled: true },
        },
        {
          label: "Document name",
          field: "document_name",
          filterOptions: { enabled: true },
        },
        {
          label: "Notes",
          field: "notes",
          filterOptions: { enabled: true },
        },
        // Trucking_id

        {
          label: "Updated date",
          field: "date",
          width: "220px",
          tdClass: "text-center",
          filterOptions: { enabled: true },
        },
        {
          label: "Updated by",
          field: "fullName",
          width: "220px",
          tdClass: "text-center",
          filterOptions: { enabled: true },
        },

        // Trucking_id

        {
          label: "Action",
          tdClass: "text-center",
          field: "action",
          width: "220px",
        },
      ],
      document_rows: [],
      activeForm: true,
      activeTabAll: 0,
      reloadShipmentDetail: 0,
    };
  },
  watch: {
    activeTabAll(n, o) {
      // click tab quote load lại dự liệu để lấy shipment mới
      if (n == 2) {
        this.reloadShipmentDetail++;

        if (this.request_quotation?.id) {
          this.$store.dispatch(
            "masterData/fetchDetailBooking",
            this.request_quotation.id
          );
        }
      }
    },
  },

  mounted() {
    if (this.booking_note == null) {
      this.booking_note = {
        showAddMore: [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ],
        status_id: this.request_quotation.status_id,
        shipping_line: this.request_quotation.shipping_line,
        company_id: this.request_quotation.company_id,
        company_name: this.request_quotation.customer_company_name,
        customer_name: this.request_quotation.customer_name,
        sale_name: this.request_quotation.sale_name,
        vessel_name: this.request_quotation.vessel_name,
        pol_name: this.request_quotation.pol_name,
        pod_name: this.request_quotation.pod_name,
        placeOfDelivery_name: null,
        goods_type_name: this.request_quotation.goods_type_name,
        service_type: "3",
        customer_id: this.request_quotation.customer_id,
        customer_email: this.request_quotation.customer_email,
        sale_id: this.request_quotation.sale_id,
        booking_date: moment().format("DD/MM/YY HH:mm"),
        booking_no: this.request_quotation.id,
        place_of_stuffing: this.request_quotation.place_of_stuffing,
        contact: this.request_quotation.contact,
        closing_time: this.request_quotation.closing_time,
        cut_si_vgm: this.request_quotation.cut_si_vgm,
        pol_port: this.request_quotation.pol_port,
        pod_port: this.request_quotation.pod_port,
        placeOfDelivery: null,
        eta: this.request_quotation.eta,
        etd: this.request_quotation.etd,
        goods_type: this.request_quotation.goods_type,
        packageNumber: this.request_quotation.packageNumber,
        trong_luong: this.request_quotation.trong_luong,
        so_khoi: this.request_quotation.so_khoi,
        note: `1. Please contact our operation 2 hours before loading cargo to stuffing place.
    2. Please bring a booking note, declaration, barcode, vgm.
    3. Wooden packages & wooden products must be fumigated at shipper's premise.
    4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.
    5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.
    6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking.
    7. For European trade lane: HS code of cargo required to provide at least two days before ETD.
    8. For US/Canada trade lanes: No personal effects are accepted.
    9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.

    In case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.`,
      };
      this.reloadNote++;
    }
    this.reload++;
    this.$loading.show();
    this.activeTabAll = 0;
    if (
      this.request_quotation != null &&
      this.request_quotation.hasOwnProperty("files") &&
      this.request_quotation.files != undefined
    ) {
      this.request_quotation?.files.map((e) => {
        e.fullName = e.fullName;
        e.text = e.name;
        e.notes = e.notes || "";
        e.tms_path = e.tms_path ? `${e.tms_path}` : "";
        if (e.path) {
          const path = e.path.split(".")[0];
          e.download_path =
            $ctx.API_URL +
            "uploadFile/" +
            path +
            "?apiKey=" +
            localStorage.getItem("accessToken") +
            "&name=" +
            e.name;
        }

        this.document_rows.push(e);
      });
    }
    if (
      this.request_quotation != null &&
      this.request_quotation.accept_files != undefined
    ) {
      if (this.request_quotation.accept_files.length > 0) {
        this.request_quotation.accept_files.map((e) => {
          e.fullName = e.fullName;
          e.text = e.name;
          e.notes = e.notes || "";
          e.tms_path = e.tms_path ? `${e.tms_path}` : "";
          if (e.path) {
            const path = e.path.split(".")[0];

            e.download_path =
              $ctx.API_URL +
              "uploadFile/" +
              path +
              "?apiKey=" +
              localStorage.getItem("accessToken") +
              "&name=" +
              e.name;
          }
          this.document_rows.push(e);
        });
      }
    }

    setTimeout(() => {
      if (this.objectView) {
        this.$nextTick(() => {
          const scrollContainer = this.$refs.scrollContainer;
          scrollContainer.$el.scrollTo(0, scrollContainer.$el.scrollHeight);
        });
      }
      this.$store.commit("tabView/SET_OBJECT_VIEW", false);
      this.$loading.hide();
    }, 500);
    if (this.booking?.id) {
      this.bookingID = this.booking.id || "";
    } else {
      this.bookingID = JSON.parse(localStorage.getItem("idBooking")) || "";
    }

    if (
      this.request_quotation &&
      ![5, 6, 61, 16].includes(this.status) &&
      !this.isCustomer &&
      (this.shipment_detail == null || this.shipment_detail.length < 10)
    ) {
      setTimeout(() => {
        this.updateShipmentDetail();
      }, 1000);
    }
  },
  computed: {
    ...mapState("masterData", ["locations"]),
    objectView: function () {
      return this.$store.getters["tabView/objectView"];
    },
    isReadonly() {
      return (this.status ==
        this.$Utils.BOOKING_NAME.CONFIRMED_QUOTATION.toString() &&
        !this.isCustomer) ||
        (this.status ==
          this.$Utils.BOOKING_NAME.RECEIVED_REVISE_REQUEST.toString() &&
          !this.isCustomer)
        ? false
        : this.readonlyBookingNote;
    },
  },

  methods: {
    printPage(row) {
      this.type = this.checkInput(row.name, this.typeViewImg);
      this.$store
        .dispatch("attachFile/viewFile", {
          id: row.path,
          name: row.name,
        })
        .then((rs) => {
          if (rs.data.message === "success!") {
            if (this.type) {
              this.images = "data:image/png;base64," + rs.data.result;
              const newTab = window.open("", "_blank");
              newTab.document.write(
                "<html><head><title>View and Print Image</title></head><body>"
              );
              newTab.document.write(
                '<img src="' + this.images + '" alt="Image"/>'
              );
              newTab.document.write("</body></html>");
              newTab.document.close();

              newTab.onload = function () {
                newTab.print();
              };
            } else {
              this.base64 = rs.data.result;
              this.$bvModal.show("view-file-print");
              if (this.base64) {
                this.openPdf();
              }
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: rs.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .finally(() => {
          this.$loading.hide();
        });
    },

    openPdf() {
      this.pdfData = this.base64;
      const byteCharacters = atob(this.pdfData);
      const byteArrays = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteArrays], { type: "application/pdf" });
      this.pdfUrl = URL.createObjectURL(blob);
      setTimeout(() => {
        this.printPdf();
      }, 100);
    },
    printPdf() {
      const pdfEmbed = this.$refs.pdfEmbed;
      pdfEmbed.focus();
      pdfEmbed.contentWindow.print();
    },

    async handCancelBooking(bvModalEvt) {
      this.$loading.show();
      bvModalEvt.preventDefault();
      var validate = await this.$refs.cancelRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$loading.hide();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      useJwt
        .put("wr1?objectType=CancelBooking", {
          id: this.request_quotation.id,
          cancel_reason: this.cancel_reason,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking Cancelled success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("cancel-booking");

          this.$emit("CancelBookingEvent");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking Cancel error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    download(data, filename, type) {
      var file = new Blob([data], { type: type });
      if (window.navigator.msSaveOrOpenBlob)
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      else {
        // Others
        var a = document.createElement("a"),
          url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      }
    },
    downloadWithCustomName(blobData, fileName) {
      const blobURL = window.URL.createObjectURL(blobData);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = blobURL;
      a.download = fileName; // Sử dụng tên tệp từ trường "name"
      document.body.appendChild(a);

      a.click();

      window.URL.revokeObjectURL(blobURL);
      document.body.removeChild(a);
    },
    isImage(filePath) {
      // List of common image extensions
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".bmp",
        ".webp",
      ];

      // Extract the file extension from the file path
      const fileExtension = filePath
        .slice(((filePath.lastIndexOf(".") - 1) >>> 0) + 2)
        .toLowerCase();

      // Check if the file extension is in the list of image extensions
      return imageExtensions.includes(`.${fileExtension}`);
    },
    isImageOrPdf(filePath) {
      // List of common image and PDF extensions
      const supportedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.pdf'];

      // Extract the file extension from the file path
      const fileExtension = filePath.slice(((filePath.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

      // Check if the file extension is in the list of supported extensions
      return supportedExtensions.includes(`.${fileExtension}`);
    },
    downloadFile(file, id) {
      this.$loading.show();
      let url = file.download_path || file.tms_path;

      // Fetch the file data
      useJwt
        .get(`wr1?objectType=DownloadTmsFile&search=${url}`)
        .then((res) => {
          // Assuming res.data.result contains the Base64 string
          const base64String = res.data.result;

          // Decode the Base64 string
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "image/jpeg" }); // Adjust MIME type if needed

          // Create a link element
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = file.name || "downloaded_image.jpg"; // Set the file name

          // Append the link to the body and click it to trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href); // Revoke the object URL
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        }).finally(() => {
          this.$loading.hide();
        });
    },
    sendShipmentDetailsTms(payload) {
      this.$emit("NewShipmentToTMS");
      if (payload == 7) {
        this.updateShipmentDetail();
      }
    },
    sendShipmentDetailsFast(payload) {
      this.$emit("NewShipmentToFast");

      if (payload == 7) {
        this.updateShipmentDetail();
      }
    },

    updateShipmentDetailSendTms(e) {
      let payload = null;
      if (e) {
        payload = e;
      } else {
        payload = this.request_quotation;
      }
      // e.valueVan
      const serviceData = {
        3: "LCL",
        1: "AIR",
        2: "FCL",
        4: "Customs",
        5: "containerTrucking",
        6: "van",
      };

      const shipmentData = {
        ...this.$refs.shipmentDetail.$refs[
          serviceData[this.request_quotation.service_type]
        ].shipment_detail,
      };

      if (this.request_quotation.service_type.toString() == "6") {
        shipmentData.valueVan = payload.valueVan;
        this.$refs.shipmentDetail.$refs[
          serviceData[this.request_quotation.service_type]
        ].shipment_detail.valueVan = payload.valueVan;
      }
      // nếu là container thì gán lại valueContainer
      if (this.request_quotation.service_type.toString() == "5") {
        shipmentData.valueContainer = payload.valueContainer;
        this.$refs.shipmentDetail.$refs[
          serviceData[this.request_quotation.service_type]
        ].shipment_detail.valueContainer = payload.valueContainer;
      }

      // nếu là LCL thì gán lại showAddMore
      if (this.request_quotation.service_type.toString() == "3") {
        shipmentData.showAddMore = payload.showAddMore;
        this.$refs.shipmentDetail.$refs[
          serviceData[this.request_quotation.service_type]
        ].shipment_detail.showAddMore = payload.showAddMore;
      }

      useJwt
        .put("wr1?objectType=UpdateShipmentDetail", shipmentData)
        .then((response) => {
          this.reloadShipmentDetail++;
        })
        .catch((error) => console.log(error))
        .finally(() => this.$loading.hide());
    },

    updateShipmentDetail() {
      const serviceData = {
        3: "LCL",
        1: "AIR",
        2: "FCL",
        4: "Customs",
        5: "containerTrucking",
        6: "van",
      };

      useJwt
        .put(
          "wr1?objectType=UpdateShipmentDetail",
          this.$refs.shipmentDetail.$refs[
            serviceData[this.request_quotation.service_type]
          ].shipment_detail
        )
        .then((response) => {
          this.reloadShipmentDetail++;
        })
        .catch((error) => {
          throw new Error(
            "Lỗi cập nhập ShipmentDetai Khi chuyển trạng thái NewShipment "
          );
        })
        .finally(() => this.$loading.hide());
    },
    handEditBookingNote() {
      this.$loading.show();
      useJwt
        .put("bookingNoteFromBooking", {
          booking_id: this.request_quotation.id,
          ...this.booking_note,
          eta: this.booking_note.eta ? this.booking_note.eta : "",
          etd: this.booking_note.etd ? this.booking_note.etd : "",
        })
        .then((response) => {
          if (response.data.message == "success!") {
            this.readonlyBookingNote = true;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Update Booking Note Success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: rs.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: rs.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    postBookingNote() {
      if (this.status == 17) {
        this.createBookingNote();
      }
      if (this.status == 62) {
        this.updateBookingNote();
      }
      // return this.isUpdate
      //     ? this.updateBookingNote()
      //     : this.createBookingNote()
    },
    createBookingNote() {
      return new Promise((resolve, reject) => {
        useJwt
          .post("bookingNoteFromBooking", {
            booking_id: this.request_quotation.id || this.booking.id,
            ...this.booking_note,
            eta: this.booking_note.eta ? this.booking_note.eta : "",
            etd: this.booking_note.etd ? this.booking_note.etd : "",
          })
          .then((response) => {
            // console.log(response)

            if (response.data.message == "success!") {
              ReleaseBooking(
                this.request_quotation.id || this.booking.id
              ).finally((response) => {
                this.$emit("EditBookingEvent");
              });
              resolve(response.data.meta.bookingNoteId);
            } else {
              resolve(false);
            }
          })
          .catch((error) => {
            resolve(false);
          })
          .finally(() => this.$loading.hide());
      });
    },
    updateBookingNote() {
      this.$loading.show();
      useJwt
        .put("bookingNoteFromBooking", {
          booking_id: this.request_quotation.id,
          ...this.booking_note,
          eta: this.booking_note.eta ? this.booking_note.eta : "",
          etd: this.booking_note.etd ? this.booking_note.etd : "",
        })
        .then((response) => {
          if (response.data.message == "success!") {
            this.readonlyBookingNote = true;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Update Booking Note Success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });

            ReceivedReviseRequest(
              this.request_quotation.id || this.booking.id
            ).finally((response) => {
              this.$emit("EditBookingEvent");
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: rs.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: rs.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    async reviseBookingNote() {
      try {
        const rs = await ReceivedReviseRequest(
          this.request_quotation.id || this.booking.id
        );
        if (rs.code == "200") {
          this.readonlyBookingNote = true;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Received Revise Request Success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          CustomerBooking(this.request_quotation.id);
          this.$emit("EditBookingEvent");
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: rs?.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: rs.data.message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    previewURL() {
      const $viewer = this.$viewerApi({
        images: this.images,
      });
    },

    editDateLess30day() {
      // 9  11   10 - cancel

      if ([9, 10].includes(this.status)) {
        if (
          (this.request_quotation.canceled_date == null && this.status == 10) ||
          (this.request_quotation.completed_date == null && this.status == 9) ||
          this.request_quotation.locked == 0
        ) {
          return true;
        } else {
          if (this.request_quotation.canceled_date != null) {
            var dateCancel = this.request_quotation.canceled_date.split("/");
            if (
              (this.dhm(
                new Date() -
                  new Date(+dateCancel[2], dateCancel[1] - 1, +dateCancel[0])
              ) < 31 &&
                this.status == 10) ||
              this.request_quotation.locked == 0
            ) {
              return true;
            }
          } else {
            var dateCom = this.request_quotation.completed_date.split("/");

            if (
              this.dhm(
                new Date() - new Date(+dateCom[2], dateCom[1] - 1, +dateCom[0])
              ) < 31 &&
              this.status == 9
            ) {
              return true;
            }
          }
        }
      }
      return false;
    },
    dhm(ms) {
      const days = Math.abs(Math.floor(ms / (24 * 60 * 60 * 1000)));
      return days;
    },
    checkInput(input, words) {
      return input && words
        ? words.indexOf(input.split(".").pop()) > -1
        : false;
    },
    async removeFile(row) {
      var bookingId =
        this.request_quotation.files.filter((e) => e.path == row.path).length >
        0
          ? "-1"
          : this.request_quotation.id;
      var res = await this.$bvModal.msgBoxConfirm(
        "Are you sure you want to delete this file?",
        { title: "Delete file", size: "sm" }
      );
      if (res) {
        this.document_rows = this.document_rows.filter(
          (e) => e.path != row.path
        );
        this.request_quotation.files = this.request_quotation.files.filter(
          (e) => e.path != row.path
        );
        this.$store.dispatch("attachFile/deleteFile", {
          bookingId: bookingId,
          request_quotation_id: this.request_quotation.id,
          request_quotation_files: this.request_quotation.files,
          path: row.path,
        });
      }
    },
    saveFile() {
      this.responseFileUp.isRequestFile =
        this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
          ? "0"
          : "1";
      this.responseFileUp.bookingId = this.request_quotation.id;
      this.responseFileUp.size = `${this.file.size}`;
      this.responseFileUp.notes = this.notes;

      this.$store.dispatch("attachFile/upFile", this.responseFileUp);
      this.responseFileUp.date = moment(new Date()).format(
        "DD/MM/YYYY HH:mm:ss"
      );

      this.responseFileUp.text = this.responseFileUp.name;
      this.responseFileUp.download_path =
        $ctx.API_URL +
        "uploadFile/" +
        this.responseFileUp.path +
        "?apiKey=" +
        localStorage.getItem("accessToken") +
        "&name=" +
        this.responseFileUp.name;
      this.responseFileUp.fullName = this.userData.fullName;
      this.document_rows.push(this.responseFileUp);
      // this.$bvModal.hide("file-notes");
      this.fileUpload = false;
    },
    uploadSuccess: function (file, res) {
      this.responseFileUp = "";
      this.file = "";

      if (file && res.message == "success!") {
        this.nameFile = res.result.name;
        this.responseFileUp = res.result;
        // this.$bvModal.show("file-notes");
        this.fileUpload = true;
        this.notes = "";
        this.file = file;
      }
    },
    viewFile(row) {
      this.$loading.show();
      if (row.tms_path) {
        this.type = this.checkInput(row.name, this.typeViewImg);
        if (this.type) {
          this.images = [row.tms_path];
          this.previewURL();
          this.$loading.hide();
        } else {
          this.base64 = row.tms_path;
          this.$bvModal.show("view-file");
          this.$loading.hide();
        }
      } else {
        this.type = this.checkInput(row.name, this.typeViewImg);
        this.$store
          .dispatch("attachFile/viewFile", {
            id: row.path,
            name: row.name,
          })
          .then((rs) => {
            if (rs.data.message == "success!") {
              if (this.type) {
                this.images = ["data:image/png;base64," + rs.data.result];
                this.previewURL();
              } else {
                this.base64 = `data:application/pdf;base64,${rs.data.result}`;
                this.$bvModal.show("view-file");
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: rs.data.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            }
          })
          .finally(() => {
            this.$loading.hide();
          });
      }
    },
    vdropzoneError(file, errorMessage) {
      this.$refs.addFile.removeFile(file);
      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>
